module.exports = __webpack_public_path__ + "img/MF.5d653ff0.png";